// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__27nsV","title":"Info_title__YR43I","links":"Info_links__1bz6z","link":"Info_link__3Qzkq","logo":"Info_logo__3Wx9T"};